module.exports = __webpack_public_path__ + "img/arrow-square-right.41200624.svg";